module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "weui-cell"
  }, [_c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('textarea', {
    staticClass: "weui-textarea",
    attrs: {
      "name": _vm.name,
      "cols": _vm.cols,
      "rows": _vm.rows,
      "autofocus": _vm.autofocus
    },
    on: {
      "click": _vm.onItemClick,
      "input": _vm.onItemInput,
      "change": _vm.onItemChange,
      "focus": _vm.onItemFocus,
      "blur": _vm.onItemBlur
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-textarea-counter"
  }, [_vm._v(_vm._s(_vm.addon))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-c0865ce2!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/textarea.vue
// module id = 284
// module chunks = 0